/**
 * Nao — Kit de Inicio: selector visual de acabados.
 * Cada dot lleva data-image (URL ya dimensionada); al seleccionarlo la
 * imagen del escaparate cambia con un crossfade corto. El selector es solo
 * visual por ahora — cuando el producto tenga variantes reales de acabado,
 * este módulo pasará a sincronizar variant_id con el checkout (§19.2).
 */

const FADE_MS = 150;

const initKit = (root) => {
  (root || document).querySelectorAll('[data-nao-kit]').forEach((kit) => {
    if (kit.dataset.naoInit) return;
    kit.dataset.naoInit = 'true';

    const img = kit.querySelector('.js-nao-kit-image');
    const dots = Array.from(kit.querySelectorAll('.js-nao-kit-color'));
    const live = kit.querySelector('.js-nao-kit-live');
    if (!img || dots.length === 0) return;

    img.addEventListener('load', () => img.classList.remove('nao-kit__img--fading'));

    const select = (dot) => {
      dots.forEach((d) => d.setAttribute('aria-pressed', String(d === dot)));
      if (live) live.textContent = dot.dataset.label || '';

      const src = dot.dataset.image;
      if (!src || img.dataset.current === src) return;
      img.dataset.current = src;
      img.classList.add('nao-kit__img--fading');
      setTimeout(() => {
        img.src = src;
      }, FADE_MS);
    };

    dots.forEach((dot) => dot.addEventListener('click', () => select(dot)));
  });
};

initKit(document);

document.addEventListener('shopify:section:load', (event) => {
  initKit(event.target);
});
